var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('el-popover',{attrs:{"trigger":_vm.trigger,"placement":_vm.placement,"title":_vm.title}},[_c('ext-text',{attrs:{"content":_vm.content}}),(_vm.isBtnShow)?_c('el-button',{attrs:{"slot":"reference","size":_vm.btnSize},slot:"reference"},[_vm._v(_vm._s(_vm.btnLabel))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }